import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { Filler } from "chart.js";
import Chart from "chart.js/auto";
import { dummyPerChange } from "./dummydata";
import ReactTooltip from "react-tooltip";
import { AiFillQuestionCircle } from "react-icons/ai";
import { getSuggestedQuery } from "@testing-library/react";

Chart.register(Filler);

const northHemColors = {
  spring: "#16a34a",
  summer: "#e11d48",
  fall: "#ea580c",
  winter: "#3b82f6",
};

const northHemColorsFill = {
  spring: "rgba(152, 235, 61, 0.4)",
  summer: "rgba(244, 67, 54, 0.4)",
  fall: "rgba(255, 235, 59, 0.4)",
  winter: "#a5f3fc",
};

const southHemColors = {
  fall: "#16a34a",
  winter: "#e11d48",
  spring: "#ea580c",
  summer: "#3b82f6",
};

const southHemColorsFill = {
  fall: "rgba(152, 235, 61, 0.4)",
  winter: "rgba(244, 67, 54, 0.4)",
  spring: "rgba(255, 235, 59, 0.4)",
  summer: "rgba(6, 147, 227, 0.4)",
};
const initialGraphedSeason = [
  {
    id: "spring",
    label: "Spring",
    data: Object.values(dummyPerChange.spring),
    backgroundColor: "#98EB3D",
    borderColor: "#98EB3D",
    pointRadius: 0,
    tension: 1,
  },
];

export default function PerChangeGraph(props) {
  const { perChange, formValues } = props;

  const [season, setSeason] = useState("summer");
  const [graphedSeason, setGraphedSeason] = useState([]);
  const [renderedGraph, setRenderedGraph] = useState([]);

  const latitude = 1;

  useEffect(() => {
    const allSeasons = [];
    for (let obj in perChange) {
      const newObj = {
        id: obj,
        label: obj,
        data: perChange[obj],
        fill: {
          target: "origin",
          above:
            latitude > 0 ? northHemColorsFill[obj] : southHemColorsFill[obj],
          below:
            latitude > 0 ? northHemColorsFill[obj] : southHemColorsFill[obj],
        },
        backgroundColor:
          latitude > 0 ? northHemColors[obj] : southHemColors[obj],
        borderColor: latitude > 0 ? northHemColors[obj] : southHemColors[obj],
        pointRadius: 0,
        tension: 0.4,
      };
      allSeasons.push(newObj);
      if (obj === "summer") {
        setRenderedGraph([newObj]);
      }
    }
    setGraphedSeason(allSeasons);
  }, [perChange]);

  const changeSeason = (evt) => {
    const { value } = evt.target;
    if (value === "all") {
      setSeason("");
      setRenderedGraph([
        { ...graphedSeason[0], fill: false },
        { ...graphedSeason[1], fill: false },
        { ...graphedSeason[2], fill: false },
        { ...graphedSeason[3], fill: false },
      ]);
    } else {
      setSeason(value);
      setRenderedGraph(
        graphedSeason.filter((obj) => {
          return obj.id == value;
        })
      );
    }
  };

  return (
    <div className="LineChartContainer">
      <div className="LineChartHeader">
        <h3>Expected Sunlight Change</h3>
        <AiFillQuestionCircle
          className="QuestionIcon"
          data-tip="This graph represents how UbiGro changes sunlight in your greenhouse.
       Quantum dots in UbiGro absorb UV and Blue light (350-500 nm) 
        and re-emits it as  red-orange light, centered at 600nm. The area below zero on the graph represents 
        absorption and the area above zero represents emission (glow). 
        Click through the different seasons to see how UbiGro
        affects your greenhouse for each season. You might notice
        the change is less in times of the year when it's cloudy or
        the days are shorter."
        />
        <ReactTooltip />
      </div>
      <div>
        <form className="seasonRadioButtons">
          <label>
            <input
              type="radio"
              value="spring"
              id="spring"
              checked={latitude > 0 ? season === "spring" : season === "summer"}
              onChange={changeSeason}
            />
            Spring
          </label>
          <label>
            <input
              type="radio"
              value="summer"
              id="summer"
              checked={latitude > 0 ? season === "summer" : season === "winter"}
              onChange={changeSeason}
            />
            Summer
          </label>
          <label>
            <input
              type="radio"
              value="fall"
              id="fall"
              checked={latitude > 0 ? season === "fall" : season === "spring"}
              onChange={changeSeason}
            />
            Fall
          </label>
          <label>
            <input
              type="radio"
              value="winter"
              id="winter"
              checked={latitude > 0 ? season === "winter" : season === "summer"}
              onChange={changeSeason}
            />
            Winter
          </label>
          <label>
            <input
              type="radio"
              value="all"
              id="all"
              checked={season === "all"}
              onChange={changeSeason}
            />
            All
          </label>
        </form>
      </div>
      <div className="LineChart">
        <Line
          data={{
            labels: Object.keys(dummyPerChange.summer),
            datasets: renderedGraph,
          }}
          height={400}
          width={200}
          options={{
            maintainAspectRatio: false,
            scales: {
              x: {
                min: 50,
                max: 500,
                stepSize: 10,
                title: {
                  display: true,
                  text: "Wavelength (nm)",
                  color: "#7A7A7A",
                },
              },
              y: {
                min: -3,
                max: 2,
                title: {
                  display: true,
                  text: "PFD (µmol/m²/sec)",
                  color: "#7A7A7A",
                },
              },
            },
            events: [],
          }}
        />
      </div>
      <p className="GraphDisclaimer">
        *This graph represents the maximum benefit for UbiGro in full sunlight.
        Results may vary based on weather patterns in your area and the light
        transmission properties of your greenhouse covering.
      </p>
    </div>
  );
}
